<template>
    <div class="mt-1 mb-3">
        <template v-for="(record, index) in lodash.get(data.useForm.modelRef, itemsKey)" :key="record.id || record._id">
            <Row v-if="record.isDelete !== true" type="flex" justify="center">
                <Col v-if="canDelete && lodash.get(data.useForm.modelRef, itemsKey).filter(d=>!d.isDelete).length > 1" :xs="{ span: 2 }" :md="{ span: 1 }">
                    <Button
                            class="btn-danger mb-2"
                            size="small"
                            @click="() => onClickDelete(record, index)"
                    >
                        <CIcon file="delete.svg"></CIcon>
                    </Button>
                </Col>
                <Col :xs="{ span: canDelete ? 22 : 24 }">
                    <TemplateBuilder
                            :rowProp="data.rowProp"
                            :useForm="data.useForm"
                            :fields="
                                createField({
                                    props,
                                    data: { ...data },
                                    key: `${itemsKey}.${index}`,
                                    items: lodash.get(data.useForm.modelRef, itemsKey),
                                    initItems: lodash.get(data.useForm.initialModel, itemsKey),
                                    isLoading
                                })
                            "
                            :skeleton="isLoading"
                    ></TemplateBuilder>
                </Col>
            </Row>
        </template>
        <Row type="flex" justify="center">
            <Col :xs="{ span: canDelete ? 22 : 24 }" :md="{ span: canDelete ? 11 : 12 }">
                <Button v-if="canCreate" class="btn-success" size="small" @click="() => onClickAdd()">
                    <CIcon file="plus.svg"></CIcon>
                    <span>{{ $t("model.inspectionOfficer.labels.add") }}</span>
                </Button>
            </Col>
        </Row>
    </div>
</template>

<script>
    import { defineAsyncComponent, defineComponent, reactive } from "vue";
    import { state as stateApp } from "../../../../../../app.logic";
    import lodash from "lodash";
    import { Button, Col, Row } from "ant-design-vue";
    import { randomUuid } from "../../../../../../utils/util";
    import { clearRulesStartsWith } from "../../../../../../utils/validate";
    import { initData, isLoading, createField } from "./release-officer.logic";

    export default defineComponent({
    components: {
        Button,
        Col,
        Row,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../../../components/input/template-builder/TemplateBuilder")),
        CIcon: defineAsyncComponent(() => import("../../../../../../components/icon/CIcon")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: {},
        viewOnlyInspection: { default: false },
        visibleCardTitle: { default: false },
        dataProp: {},
        itemsKey: {},
        fetchCriteria: {},
        canCreate: {},
        canDelete: {},
        informKey: {},
        request: {}
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        const onClickAdd = () => {
            lodash.get(data.useForm.modelRef, props.itemsKey).push({
                _id: randomUuid()
            });
        };
        const onClickDelete = (record, index) => {
            if (record.id) {
                record.isDelete = true;
            } else {
                Promise.resolve()
                    .then(() => clearRulesStartsWith({ useForm: data.useForm, key: `${props.itemsKey}.` }))
                    .then(() => lodash.get(data.useForm.modelRef, props.itemsKey).splice(index, 1));
            }
        };
        if (!data.useForm.modelRef.id && data.useForm.modelRef.refRequestType?.key === "1" && data.useForm.modelRef.refRequestDoc?.key === "02")
            onClickAdd();
        initData({ props, data, refs });
        return { props, data, refs, isLoading, lodash, createField, onClickAdd, onClickDelete };
    }
});
</script>
